<template>
	<div>
		<div ref="equity" class="equity-show" style="">
			<div class="equity">
				<div class="left">权益功能</div>
				<div class="right">
					<div class="right-item">
						<div class="right-item-t">免费版</div>
						<div @click.stop="openCode()" class="right-item-btn btn1">免费使用</div>
					</div>
					<div class="right-item">
						<div class="right-item-t">基础版</div>
						<div @click.stop="openCode()" class="right-item-btn btn2">立即开通</div>
					</div>
					<div class="right-item">
						<div class="right-item-t">专业版</div>
						<div @click.stop="openCode()" class="right-item-btn btn3">立即开通</div>
					</div>
					<div class="right-item">
						<div class="right-item-t">企业版</div>
						<div @click.stop="openCode()" class="right-item-btn btn4">立即开通</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 商户saas -->
		<div style="background-color: #fff">
			<Saas :flag="'1'"></Saas>
		</div>
		<div style="background-color: #fff;">
			<div class="member">
				<h2 class="member-t">不同版本对比</h2>
				<p class="member-p">版本功能清晰对比，满足不同经营需求，助力商户找到最合适的成长方案</p>
				<div class="version-img">
					<img src="../../static/deposit/version-img.png" alt="" />
				</div>
			</div>
		</div>
		<StoreImg></StoreImg>
		<div class="pb-60" style="background-color: #fff;">
			<Service></Service>
		</div>
		<ConsultDialog v-if="centerDialogVisible" @close="close"></ConsultDialog>
	</div>
</template>
<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	import ConsultDialog from '@/components/ConsultDialog.vue'
	export default {
		name: 'Index',
		components: {ConsultDialog},
		data() {
			return {
				centerDialogVisible: false,
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
			}
		},
		methods: {},
		mounted() {
			this.sliders = [{
					img: require('../../static/home/1banner.png'),
					imgTit: require('../../static/home/top-banner1-t.png')
				},
				{
					img: require('../../static/home/2banner.png'),
					imgTit: require('../../static/home/top-banner2-t.png')
				},
			],
			// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 560 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 560 / 1920 * this.screeWith
			}
			window.addEventListener('scroll', this.handleScroll)
		},
		computed: {
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}

		},
		methods: {
			close(flag) {
				this.centerDialogVisible = false
			},
			openCode() {
				this.centerDialogVisible = true
			},
			handleScroll() {
				this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
				let equity = document.querySelector('.equity-show')
				if (this.scroll > 400) { 
					equity.style.display = 'block'
				} else {
					equity.style.display = 'none'
				}
			},
		}
	}
</script>

<style scoped>
	.equity-show {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 99;
		display: none;
		background-color: #fff;
		box-shadow: 0px 5px 15px 0px rgba(230,230,230,0.5);
	}
	.equity {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		align-items: flex-end; /* 让子元素底部对齐 */
		color: #333333;
		padding-top: 30px;
		padding-bottom: 20px;
	}
	.equity .left {
		font-weight: 600;
		font-size: 32px;
		color: #333333;
	}
	.equity .right {
		margin-left: 114px;
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.equity .right .right-item {
		text-align: center;
		margin-right: 23px;
	}
	.equity .right .right-item:last-child {
		margin-right: 0px;
	}
	.equity .right .right-item .right-item-t {
		font-weight: 600;
		font-size: 24px;
		margin-bottom: 20px;
	}
	.equity .right .right-item .right-item-btn {
		font-weight: 600;
		padding: 8px 0px;
		width: 220px;
		border-radius: 25px;
		font-size: 18px;
	}
	.equity .right .right-item .btn1 {
		color: #3F575F;
		border: 1px solid #3F575F;
	}
	.equity .right .right-item .btn2 {
		background: linear-gradient( 141deg, #FEEAC1 0%, #FFCA74 100%), #B25F05;
	}
	.equity .right .right-item .btn3 {
		background: linear-gradient( 141deg, #FBD7C1 0%, #F99864 100%);
	}
	.equity .right .right-item .btn4 {
		background: linear-gradient( 135deg, #D4EEFF 0%, #74C8FF 100%);
		
	}
	.member {
		width: 1200px;
		margin: 0 auto;
		padding-top: 70px;
		padding-bottom: 70px;
	}

	.member-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}

	.member-p {
		font-weight: 600;
		font-size: 12px;
		color: #999999;
		margin-bottom: 50px;
		text-align: center;
		margin-top: 15px;
	}
	.member-img {
		width: 1520px;
		margin: 0 auto;
	}
	.member-img img {
		width: 100%;
		height: auto;
	}
	.member-img-item {
		position: relative;
		cursor: pointer;
	}
	
	.member-img-item img {
		width: 360px;;
		height: 172px;
	}
	
	.menber-btn {
		position: absolute;
		left: 40px;
		top: 50%;
		transform: translateY(-50%);
		z-index: 10;
	}
	
	.menber-btn .menber-btn-t {
		font-weight: 600;
		font-size: 26px;
		color: #333333;
	}
	
	.menber-btn .menber-btn-desc {
		font-size: 13px;
		color: #FE3D3A;
	}
	
	.member-img-item:hover .menber-btn-t {
		color: #FE3D3A;
	}
	.version-img {
		width: 1200px;
		margin: 0 auto;
	}
	.version-img img {
		width: 1200px;
		height: 1598px;
	}
</style>


// WEBPACK FOOTER //
// src/view/deposit.vue